module.exports = __webpack_public_path__ + "img/tf.b0edf6da.png";